//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StarRating from 'vue-star-rating'

export default {
    components: {
        StarRating,
    },
    props: {
        members: { type: Array, default: () => [] },
        globalRate: { type: Number, default: 0 },
    },
}
